import {Values} from '@wix/devzai-utils-common';

export const WixAppRuntimeEnvironment = {
    Local: 'local',
    Staging: 'staging',
    Production: 'production'
} as const;

export type WixAppRuntimeEnvironment = Values<typeof WixAppRuntimeEnvironment>;


export namespace WixAppRuntimeEnvironment {
    export type NonProduction = Exclude<WixAppRuntimeEnvironment, typeof WixAppRuntimeEnvironment.Production>;
}